import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router";
import { getDevicesListData } from "../../utils/customer_utils";
import { PageHeading, Pager } from "../../components";
import { formatNumber } from "src/main_app/utils/common";
import { useTenantConfig } from "src/main_app/actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DevicesTableSkeleton from "./devices-table-skeleton";
import DeviceItem from "./device-item";
import moment from "moment";
import { getTotalPercentageReceived } from "src/main_app/services/apis";

// export const tableHeaders = [
//   "Site ID",
//   "Serial No",
//   "Customer",
//   "Register Read",
//   "Signal Strength (RSSI)",
//   "",
//   "",
//   "Interval Data",
//   "Output",
// ];

const DevicesPage = (props) => {
  const tenantConfig = useTenantConfig();
  const tableHeaders = tenantConfig.devices_headers;
  const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
  const history = useHistory();
  const [orderBy, setOrderBy] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [devicesList, setDevicesList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [date, setDate] = useState(yesterday);
  const isInitedRef = useRef(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [totalPercentageReceived, setTotalPercentageReceived] = useState(0);
  const [titleHunt, setTitleHunt] = useState(null);

  const goToOverview = useCallback((customer) => {
    const defaultPageDetail =
      tenantConfig.slug === "intellihub" ? "usage" : "overview";
    history.push(`/customer/${customer.id}/${defaultPageDetail}`);
  }, []);

  const onPageChange = async (pageNo, dateOverride = date) => {
    console.log("onPageChange", pageNo, date);
    const selectedDate = dateOverride;
    const { total, data } = await getDevicesListData(
      pageNo,
      limit,
      orderBy,
      selectedDate
    );
    setCurrentPage(pageNo);
    setTotal(total);
    setDevicesList(data);
  };

  const totalPercentage = async () => {
    const currentDate = moment().subtract(1, "day").format("YYYY-MM-DD");
    const threeDatesAgo = moment(currentDate)
      .subtract(3, "days")
      .format("YYYY-MM-DD");

    const {
      data: { data },
    } = await getTotalPercentageReceived({
      from: threeDatesAgo,
      to: currentDate,
    });
    setTotalPercentageReceived(data);
    // const maxPercentData = (data || []).reduce((max, item) =>
    //   parseFloat(item.Percent) > parseFloat(max.Percent) ? item : max
    // );
    // setTotalPercentageReceived(maxPercentData["Percent"]);
  };

  const onOrderChange = (newOrder) => () => {
    setOrderBy([
      newOrder,
      orderBy[0] !== newOrder ? "asc" : orderBy[1] === "asc" ? "desc" : "asc",
    ]);
    setCurrentPage(1);
  };

  const getTableColClass = (colName) =>
    [
      "allow-order",
      orderBy[0] === colName ? (orderBy[1] === "desc" ? "order-desc" : "") : "",
    ].join(" ");

  const onLoaded = useCallback(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 666);
  }, [isLoaded, setIsLoaded]);

  useEffect(() => {
    onPageChange(1).then(() => {
      onLoaded();
      isInitedRef.current = true;
    });
    return () => {
      isInitedRef.current = false;
    };
  }, [onLoaded, orderBy]);

  useEffect(() => {
    totalPercentage();
  }, []);

  useEffect(() => {
    setTitleHunt(tenantConfig.slug === "demowater" ? "ICON" : "HUNT");
    if (tenantConfig.slug === "ashburton") {
      setTitleHunt("ASHB");
    }
    if (tenantConfig.slug === "demowater") {
      //current date
      setDate(moment().format("YYYY-MM-DD"));
    }
  }, [tenantConfig.slug]);

  return (
    <div className="the-content">
      <PageHeading title="Devices" />
      <div className="container-fluid content">
        <div className="action-buttons block-center-between">
          <div className="block-center">
            <div className="header-container">
              {isLoaded && <>Summary for Customer: {titleHunt} on Date:</>}
              <span className="dropdown ml-2">
                <DatePicker
                  selected={moment(date, "YYYY-MM-DD").toDate()}
                  dateFormat="dd MMM yyyy"
                  onChange={(selectedDate) => {
                    const newDate = moment(selectedDate).format("YYYY-MM-DD");
                    setDate(newDate);
                    onPageChange(1, newDate).then(onLoaded);
                  }}
                  popperPlacement="bottom-start"
                />
              </span>
            </div>
          </div>
        </div>

        <div className="action-buttons block-center-between">
          <div className="block-center">
            <div className="header-container">
              Total percentage of data received over the last 3 days:{" "}
              {totalPercentageReceived}%
            </div>
          </div>
          <div>
            {total >= 50 && (
              <span className="mr-3">
                Showing {limit} of {formatNumber(total)} devices
              </span>
            )}
            {total < 50 && (
              <span className="mr-3">{formatNumber(total)} devices</span>
            )}
          </div>
        </div>
        {!isLoaded ? (
          <DevicesTableSkeleton tenantConfig={tenantConfig} line={limit} />
        ) : (
          <>
            <div className="table-responsive">
              <table className="table customer-list">
                <thead>
                  <tr>
                    {tableHeaders.map((header, idx) => (
                      <>
                        {header === "Signal Strength (RSSI)" ? (
                          <th
                            key={idx}
                            scope="col"
                            className={getTableColClass("signal_strength")}
                            onClick={onOrderChange("signal_strength")}
                          >
                            {header}{" "}
                            {orderBy[0] === "signal_strength" && (
                              <i className="fas fa-long-arrow-alt-up"></i>
                            )}
                          </th>
                        ) : header === "Register Read" ? (
                          <th
                            key={idx}
                            scope="col"
                            className={getTableColClass("register_reading")}
                            onClick={onOrderChange("register_reading")}
                          >
                            Register Read{" "}
                            {orderBy[0] === "register_reading" && (
                              <i className="fas fa-long-arrow-alt-up"></i>
                            )}
                          </th>
                        ) : (
                          <th key={idx}>{header}</th>
                        )}
                      </>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {devicesList.map((device, index) => (
                    <DeviceItem
                      tenantConfig={tenantConfig}
                      titleHunt={titleHunt}
                      device={device}
                      date={date}
                      key={index + ""}
                      onClick={goToOverview}
                    />
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-lg-end pagination-box">
              <Pager
                onPageChange={onPageChange}
                total={total}
                limit={limit}
                currentPage={currentPage}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DevicesPage;
